module.exports = __webpack_public_path__ + "static/media/PATS_2-768w.cd975688.png";